import { InterfaceElementsWithFilter } from '../../interface/elements-with-filter/interface.elements.with.filter';
import { SwitcherComponent } from '../../base/switcher.component';
import { activationClasses, searchParams } from '../../common/consts';

export class ElementsWithFilterPartner {

  private readonly elementsWithFilterKinds: HTMLElement[];
  private readonly countArticle: number;
  private countArticleIncreasing: number;
  private units: InterfaceElementsWithFilter[];
  private currentUnits: InterfaceElementsWithFilter[];
  private countPage: number;
  private currentPage: number;
  private readonly template: Function;
  private defaultKindIndex: number | null;
  private api: string;
  private name: string;
  private country: HTMLElement | null;
  private currentSelectedCategory: number | string | null | undefined;

  constructor(
    private elementsWithFilter: HTMLElement | null,
    private loader: HTMLElement | null,
    private switchers: HTMLElement[],
    countArticle: number,
    template: Function,
    api: string,
    name: string,
    private showMoreHtmlElement: HTMLElement | null,
    defaultKindIndex: number | null = null,
  ) {
    this.country = document.querySelector('[data-country="container"]')
    const elementsWithFilterKinds: NodeListOf<HTMLElement>
      = document.querySelectorAll('[data-elements-with-filter-kind]');
    const partnersCategoryDescription = document.querySelector('[data-partners-category-description]');
    this.elementsWithFilterKinds = Array.from(elementsWithFilterKinds);
    this.countArticle = countArticle;
    this.countArticleIncreasing = this.countArticle;
    this.units = [];
    this.currentUnits = [];
    this.countPage = 0;
    this.currentPage = 1;
    this.template = template;
    this.defaultKindIndex = defaultKindIndex;
    this.api = api;
    this.name = name;
    if (this.elementsWithFilter) {
      this.getUnits(
        this.elementsWithFilter,
        this.loader,
        this.showMoreHtmlElement
      );
    }
    this.currentSelectedCategory = '';
    if (this.showMoreHtmlElement) {
      this.showMoreHtmlElement.addEventListener('click', () => {
        this.showMore();
      });
    }
  }
  private capitalize(str: string): string {
    if (!str) return '';
    return str[0].toUpperCase() + str.slice(1).toLowerCase();
  };

  private getUnits(
    elementsWithFilter: HTMLElement | null = null,
    loader: HTMLElement | null = null,
    showMoreUnits: HTMLElement | null = null
  ): Promise<void> { // Вынести
    loader?.classList.add('active');
    return  fetch(`/api/${this.api}`, { // вынести в сервис
      method: 'GET',
      headers: {
        'Authorization': 'true'
      },
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data: any): void => { // temp type
        loader?.classList.remove(activationClasses.active);
        if (Array.isArray(data[this.capitalize(this.name)])) {
          const units: any = [];
          this.units = data[this.capitalize(this.name)];
          if (this.units.length > this.countArticle) {
            showMoreUnits?.classList.add(activationClasses.active);
          }
          this.units.forEach((item: any, index: number) => {
            if (index + 1 <= this.countArticle) {
              units.push(item);
            }
          });
          this.countPage = Math.ceil(this.units.length / this.countArticle);
          const categoryName = searchParams.get('categoryName');
          if (categoryName) {
            this.setFilterByKind(categoryName);
            this.elementsWithFilterKinds.forEach((elementsWithFilterKind: HTMLElement) => {
              if (elementsWithFilterKind.dataset.elementsWithFilterKind === categoryName) {
                elementsWithFilterKind.classList.add(activationClasses.active);
              }
            });
          } else {
            if (this.defaultKindIndex !== null) {
              const kinds: (string | undefined)[] = this.elementsWithFilterKinds
                .map(
                  (elementsWithFilterKind: HTMLElement) => elementsWithFilterKind.dataset.elementsWithFilterKind
                );
              this.setFilterByKind(kinds[this.defaultKindIndex]);
            } else {
              this.renderUnits(units, elementsWithFilter);
            }
            this.elementsWithFilterKinds[0]?.classList.add(activationClasses.active);
          }
        }
        this.switchers.forEach((switcher: HTMLElement): void => {
          new SwitcherComponent(switcher).initialize();
        });
        return data;
      }).catch(error => {
        loader?.classList.remove(activationClasses.active);
        console.error('Error fetching data:', error);
      });
  }
  private setFilterByKind(kind: string | undefined) {
    let units: InterfaceElementsWithFilter[] = [];
    this.currentPage = 1;
    this.countArticleIncreasing = this.countArticle;
    this.currentUnits = this.units.filter(
      (unit: InterfaceElementsWithFilter): boolean => unit.Category?.Name === kind
    );
    this.countPage = Math.ceil(this.currentUnits.length / this.countArticle);
    this.currentUnits.forEach((item, index) => {
      if (index + 1 <= this.countArticle) {
        units.push(item);
      }
    });

    if (kind === '-1') {
      units = this.units;
    }
    this.buttonDisplay(this.countPage <= 1);
    this.renderUnits(units, this.elementsWithFilter);
  }
  private showMore() {
    const units: InterfaceElementsWithFilter[] = []; // Вынести
    this.countArticleIncreasing += this.countArticle;
    this.currentPage++;
    if (this.currentPage <= this.countPage) {
      const currentUnits: InterfaceElementsWithFilter[] = this.currentUnits.length > 0 ? this.currentUnits : this.units;
      currentUnits.forEach((item, index) => {
        if (index + 1 <= this.countArticleIncreasing) {
          units.push(item);
        }
      });
      this.renderUnits(units, this.elementsWithFilter);
    }
    this.buttonDisplay(this.currentPage >= this.countPage);
    this.switchers.forEach((switcher: HTMLElement): void => {
      new SwitcherComponent(switcher).initialize();
    });
  }
  private buttonDisplay(isHidden: boolean) {
    if (isHidden) {
      this.elementsWithFilter?.classList.add('adaptive-margin-bottom');
      this.showMoreHtmlElement?.classList.remove(activationClasses.active);
    } else {
      this.showMoreHtmlElement?.classList.add(activationClasses.active);
      this.elementsWithFilter?.classList.remove('adaptive-margin-bottom')
    }
  }
  private renderUnits(units: InterfaceElementsWithFilter[], elementsWithFilter: HTMLElement | null) {
    if (elementsWithFilter) {
      elementsWithFilter.innerHTML = this.template(units);
    }
  }
}
